import React from "react";

type $Props = {
  classes: Object,
  className: string,
  theme: Object,
  position: string,
  showAds: boolean,
};

const Ads = ({ position, showAds }: $Props) => {
  if (!showAds) {
    return null;
  }

  let adHtml;
  let containerId;
  if (position === "header") {
    adHtml =
      '<script type="text/javascript">tohAdWrapper.display("leaderboard_1");</script>';
    containerId = "leaderboard_1";
  } else if (position === "footer") {
    adHtml =
      '<script type="text/javascript">tohAdWrapper.display("leaderboard_2");</script>';
    containerId = "leaderboard_2";
  } else {
    return null;
  }

  return (
    <div
      style={{
        textAlign: "center",
        padding: "5px 0px",
        background: "#edf1f4",
      }}
    >
      <div
        id={containerId}
        dangerouslySetInnerHTML={{
          __html: adHtml,
        }}
      />
    </div>
  );
};

export default Ads;
